module.exports = __webpack_public_path__ + "img/content_right3.8d3cf581.png";